module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_rili.40ec4.png";